import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'toNumber', pure: true})
export class ToNumberPipe implements PipeTransform {
  public transform(value: any): any {
    return value == null ? null : parseInt(value);
  }
}